/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function MacCaptionTemplatesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    MacCaptionTemplatesService: JS5Object,
    ModalService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
) {
    this.editData = {
    };
    const getData = () => {
        this.loadingIndicator.show = true;
        MacCaptionTemplatesService.getMacCaptionTemplate($routeParams.id).then((macCaptionTemplate: JS5Object) => {
            MacCaptionTemplatesService.originalEditData = _.cloneDeep(macCaptionTemplate);
            this.editData = macCaptionTemplate;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewMacCaptionTemplate();
        }
        else {
            updateMacCaptionTemplate();
        }
    };

    const updateMacCaptionTemplate = () => {
        MacCaptionTemplatesService.updateMacCaptionTemplate(this.editData).then((macCaptionTemplate: JS5Object) => {
            MacCaptionTemplatesService.originalEditData = _.cloneDeep(macCaptionTemplate);
            this.editData = macCaptionTemplate;
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewMacCaptionTemplate = () => {
        MacCaptionTemplatesService.createMacCaptionTemplate(this.editData).then((macCaptionTemplate: JS5Object) => {
            $route.updateParams({id: macCaptionTemplate.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine') &&
                _.size(_.get(this.editData, 'name')) &&
                _.size(_.get(this.editData, 'template')),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(MacCaptionTemplatesService.originalEditData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/templates/search`).search({tab: 'MacCaptionTemplates'})
        }
    ];


    this.$onInit = () => {
        SidebarService.editService = MacCaptionTemplatesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit MacCaption Template',
                        location: '/system/templates/search',
                        params: {tab: 'MacCaptionTemplates'}
                    });
                }
                getData();
            } else {
                MacCaptionTemplatesService.originalEditData = _.cloneDeep(this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create MacCaption Template',
                    location: '/system/templates/search',
                    params: {tab: 'MacCaptionTemplates'}
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        MacCaptionTemplatesService.originalEditData = null;
        MacCaptionTemplatesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            MacCaptionTemplatesService.editorForm = this.editorForm;
            BreadcrumbService.editService = MacCaptionTemplatesService;
        });
    };
}


angular.module('prism-ui.system.maccaptionTemplate').component('macCaptionTemplatesEditView', {
    templateUrl: 'system/templates/maccaptionTemplate/editor/maccaption-template-edit-view-template.html',
    controller: MacCaptionTemplatesEditViewController,
    bindings: {
    }
});
